<script>
	export let song = {}
	let keys = [ "", "B", "F", "C", "G", "D", "A", "E", "H", "Fm", "Cm", "Gm", "Dm", "Am", "Em", "Hm",]
</script>

<select bind:value={song.key}>
	{#each keys as k}
		<option value = {k}>{k}</option>
	{/each}
</select>
<input bind:value={song.artist} placeholder="autor/zpěvák"/>
<input bind:value={song.genre} placeholder="žánr" list="genres"/>
<input bind:value={song.books} placeholder="zpěvník"/>
<div>
<label>poznámky:</label>
<textarea id="note" bind:value={song.note} placeholder="poznámka" cols = 50 rows = 6/>
</div>
